/** @format */

import React from 'react';
import { FACTS_FIELD_KEYS, displayYesOrNull } from '../utilities';
import './styles.scss';
import { checkIfValueIsValid } from '../common';

export const getFloorElevatorData = (props) => {
  const { dataSet, objectText } = props;

  const factKey = FACTS_FIELD_KEYS.FLOOR_AND_ELEVATOR;

  const floorElevatorData = dataSet[factKey] || {};

  // eslint-disable-next-line no-unused-vars
  const FloorElevatorFactsRow = ({ facts, fullSize = false }) => {
    const factFieldName = facts?.factFieldName;

    if (checkIfValueIsValid(facts?.value)) {
      return (
        <div className='object-listing-accordian-list object-listing-accordian-list-no-border'>
          <div className='object-listing-accordian-list-left'>
            {objectText?.[`${factKey}Obj`]?.[factFieldName]?.label ||
              objectText?.[factKey]?.[factFieldName]?.label ||
              facts?.factFieldName}
          </div>
          <div className='object-listing-accordian-list-right'>
            {facts?.value}
          </div>
        </div>
      );
    }

    return <></>;
  };

  const FloorElevatorSection = () => {
    return (
      <div className='floorElevator-data-body'>
        <FloorElevatorFactsRow
          key=''
          facts={{
            factFieldName: 'elevator',
            value: displayYesOrNull(floorElevatorData?.elevator)
          }}
        />

        <FloorElevatorFactsRow
          key=''
          facts={{
            factFieldName: 'floor',
            value: floorElevatorData?.floor
          }}
        />

        <FloorElevatorFactsRow
          key=''
          facts={{
            factFieldName: 'totalNumberOfFloors',
            value: floorElevatorData?.totalNumberOfFloors
          }}
        />

        <FloorElevatorFactsRow
          key=''
          facts={{
            factFieldName: 'descriptionOfElevator',
            value: floorElevatorData?.descriptionOfElevator
          }}
          fullSize={true}
        />
        <FloorElevatorFactsRow
          key=''
          facts={{
            factFieldName: 'floorCommentary',
            value: floorElevatorData?.floorCommentary
          }}
          fullSize={true}
        />
      </div>
    );
  };

  return {
    component: <FloorElevatorSection />,
    factsCount: 0
  };
};
